import {
  DetailHeader,
  DetailHeaderRow,
  DetailHeaderSection,
} from 'components/DetailHeader/DetailHeader';
import { useHasWorkspacePermission } from 'hooks/useHasWorkspacePermission';
import React, { useCallback, useState } from 'react';
import { match } from 'ts-pattern';
import { formatDateTime } from 'utils/date';

import { Permissions } from '@fragment/authorization-utils/permissions';
import { PrimaryButtonV2 } from '@fragment/ui/src/components/Button/PrimaryButtonV2/PrimaryButtonV2';
import { Icon } from '@fragment/ui/src/components/Icon';

import { linkTypeToDocsUrl } from './DocsLink';
import { UpdateStripeLinkForm } from './UpdateStripeLinkForm';

type Props = {
  workspaceId: string;
  encodedLinkId: string;
  lastUpdatedTs?: string;
};

export const StripeLinkDetail = ({
  workspaceId,
  encodedLinkId,
  lastUpdatedTs,
}: Props) => {
  const canUpdate = useHasWorkspacePermission(Permissions.link.update);
  const [isFormActive, setIsFormActive] = useState(false);
  const onClick = useCallback(() => setIsFormActive(true), [setIsFormActive]);
  const closeForm = useCallback(
    () => setIsFormActive(false),
    [setIsFormActive]
  );

  return (
    <div className="flex flex-col space-y-f3">
      {match(isFormActive)
        .with(false, () => (
          <>
            <div className="grid grid-cols-2 gap-x-f2 w-full justify-items-end">
              <DetailHeader>
                <DetailHeaderSection>
                  <DetailHeaderRow
                    label="Restricted Access Key"
                    value={lastUpdatedTs ? '*'.repeat(37) : 'None'}
                  />
                  <DetailHeaderRow
                    label="Updated"
                    value={
                      lastUpdatedTs ? formatDateTime(lastUpdatedTs) : 'N/A'
                    }
                  />
                </DetailHeaderSection>
              </DetailHeader>
            </div>

            <div className="flex w-fit space-x-f2">
              {canUpdate && (
                <PrimaryButtonV2 onClick={onClick}>
                  {lastUpdatedTs ? 'Update RAK' : 'Add RAK'}
                </PrimaryButtonV2>
              )}

              <span className="flex items-center">
                <a
                  href={linkTypeToDocsUrl.StripeLink}
                  className="block text-main-500 hover:text-main transition-colors"
                  target="_blank"
                  rel="noreferrer"
                >
                  Docs <Icon type="external" />
                </a>
              </span>
            </div>
          </>
        ))
        .otherwise(() => (
          <UpdateStripeLinkForm
            onFormClose={closeForm}
            workspaceId={workspaceId}
            encodedLinkId={encodedLinkId}
          />
        ))}
    </div>
  );
};
